import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

// Pulsanti avanti/indietro nella cronologia del browser, utili soprattutto in
// modalità PWA a schermo intero su cellulare (Aggiungi a Home), dove i
// pulsanti nativi del browser non sono disponibili. Frecce piene dentro un
// cerchietto colorato per farli leggere subito come pulsanti cliccabili.
export default function HistoryNavButtons({ variant = "light" }) {
  const navigate = useNavigate();
  const btnCls = variant === "dark"
    ? "grid h-9 w-9 sm:h-10 sm:w-10 shrink-0 place-items-center rounded-full bg-white/15 text-white hover:bg-white/25"
    : "grid h-9 w-9 sm:h-10 sm:w-10 shrink-0 place-items-center rounded-full bg-navy text-white hover:bg-navy/90";
  return (
    <div className="flex shrink-0 items-center gap-1 sm:gap-1.5">
      <button type="button" onClick={() => navigate(-1)} className={btnCls} aria-label="Pagina precedente" title="Indietro" data-testid="nav-history-back">
        <ArrowLeft className="h-5 w-5" strokeWidth={2.5} />
      </button>
      <button type="button" onClick={() => navigate(1)} className={btnCls} aria-label="Pagina successiva" title="Avanti" data-testid="nav-history-forward">
        <ArrowRight className="h-5 w-5" strokeWidth={2.5} />
      </button>
    </div>
  );
}
